import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import { AssetOnAssetManagementPage } from '../models/assets/AssetOnAssetManagementPage';
import { NgForm } from '@angular/forms';
import { API_SETTINGS } from './API_SETTINGS';
import { CryptoService } from '../services/crypto.service';
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

const apiUrl = API_SETTINGS.API_URL + 'AssetOnManagementPage';

@Injectable({
  providedIn: 'root'
})
export class ApiAssetOnAssetManagementPageService {

  constructor(
    private http: HttpClient,
    public cryptoService: CryptoService
  ) { }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  getAssetOnAssetManagementPages(): Observable<AssetOnAssetManagementPage[]> {
    const url = apiUrl + '/GetAssetOnAssetManagementPages'
    return this.http.get<AssetOnAssetManagementPage[]>(url).pipe();
  }

  getAssetsOnAssetManagementPageWithCustomerId(customerId: number): Observable<AssetOnAssetManagementPage[]> {
    const url = apiUrl + '/GetAssetOnAssetManagementPagesWithCustomerId';
    return this.http.post<AssetOnAssetManagementPage[]>(url, customerId, httpOptions).pipe(
      catchError(this.handleError<AssetOnAssetManagementPage[]>('GetAssetOnAssetManagementPagesWithCustomerId'))
    );
  }

  getGlobalAssetsOnAssetManagementPage(): Observable<AssetOnAssetManagementPage[]> {
    const url = apiUrl + '/GetGlobalAssetOnAssetManagementPage';
    return this.http.post<AssetOnAssetManagementPage[]>(url, httpOptions).pipe(
      catchError(this.handleError<AssetOnAssetManagementPage[]>('GetGlobalAssetOnAssetManagementPage'))
    );
  }


  getAssetOnAssetManagementPage(id: number): Observable<AssetOnAssetManagementPage> {
    const url = `${apiUrl}/GetAssetOnAssetManagementPage/${id}`;
    return this.http.get<AssetOnAssetManagementPage>(url).pipe();
  }

  GetAssetOnAssetManagementPagesWithBaseAssetId(id: number): Observable<AssetOnAssetManagementPage> {
    const url = `${apiUrl}/GetAssetOnAssetManagementPagesWithBaseAssetId/${id}`;
    return this.http.get<AssetOnAssetManagementPage>(url).pipe();
  }

  addAssetOnAssetManagementPage(AssetOnAssetManagementPage: AssetOnAssetManagementPage): Observable<AssetOnAssetManagementPage> {
    AssetOnAssetManagementPage.customerId = +this.cryptoService.decryptData(localStorage.getItem("customerId"));
    const url = apiUrl + '/PostAssetOnAssetManagementPage'
    return this.http.post<AssetOnAssetManagementPage>(url, AssetOnAssetManagementPage, httpOptions).pipe();
  }

  updateAssetOnAssetManagementPage(id: number, AssetOnAssetManagementPage: any): Observable<AssetOnAssetManagementPage> {
    const url = `${apiUrl}/PutAssetOnAssetManagementPage/${id}`;
    return this.http.put(url, AssetOnAssetManagementPage, httpOptions).pipe(
      tap((AssetOnAssetManagementPageRes: AssetOnAssetManagementPage) => true ), //console.log()),
      catchError(this.handleError<AssetOnAssetManagementPage>('updateAssetOnAssetManagementPage'))
    )
  }

  deleteAssetOnAssetManagementPage(id: number): Observable<AssetOnAssetManagementPage> {
    const url = `${apiUrl}/DeleteAssetOnAssetManagementPage${id}`;
    return this.http.delete<AssetOnAssetManagementPage>(url, httpOptions).pipe();
  }

}
